import { render, staticRenderFns } from "./CruiseDetailsShip.vue?vue&type=template&id=343b6605&"
import script from "./CruiseDetailsShip.vue?vue&type=script&lang=js&"
export * from "./CruiseDetailsShip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports